function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".close_svg__cls-1{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "close_svg__Group_72",
  "data-name": "Group 72",
  transform: "translate(3308.582 -55.919)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "close_svg__Rectangle_1541",
  "data-name": "Rectangle 1541",
  className: "close_svg__cls-1",
  width: 33,
  height: 4,
  rx: 2,
  transform: "rotate(-45 -1558.624 4033.438)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "close_svg__Rectangle_1595",
  "data-name": "Rectangle 1595",
  className: "close_svg__cls-1",
  width: 33,
  height: 4,
  rx: 2,
  transform: "rotate(45 -1720.377 -3962.437)"
}));

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26.163 26.163"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNi4xNjMgMjYuMTYzIj4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8ZyBpZD0iR3JvdXBfNzIiIGRhdGEtbmFtZT0iR3JvdXAgNzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMzMDguNTgyIC01NS45MTkpIj4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTU0MSIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMTU0MSIgY2xhc3M9ImNscy0xIiB3aWR0aD0iMzMiIGhlaWdodD0iNCIgcng9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMzA4LjU4MiA3OS4yNTMpIHJvdGF0ZSgtNDUpIi8+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzE1OTUiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDE1OTUiIGNsYXNzPSJjbHMtMSIgd2lkdGg9IjMzIiBoZWlnaHQ9IjQiIHJ4PSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzMwNS43NTMgNTUuOTE5KSByb3RhdGUoNDUpIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgClose as ReactComponent };